import * as appConfig from './../app.config';

import { RealEstateComponent } from './../components/real-estate/real-estate.component';
import { RealEstateDetailComponent } from './../components/real-estate/real-estate-detail.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { EntityBrowseComponent } from './../shared/components/browse/entity-browse.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { EstateAgentDetailComponent } from '../components/real-estate/estate-agent-detail.component';
import { DeveloperProjectDetailComponent } from '../components/real-estate/developer-project-detail.component';
import { EstateFormRecordsComponent } from '../components/real-estate/estate-form-records.component';

const defaultRoute = {
    path: 'real-estate',
    redirectTo: 'novelties'
};

const activeModuleRoutes = {
    path: 'real-estate',
    data: {
        breadcrumbs: {
            label: 'Reality',
            icon: 'real-estate'
        },
        state: 'real-estate'
    },
    children: [
        {
            path: '',
            component: RealEstateComponent
        },
        {
            path: 'add',
            data: {
                breadcrumbs: {
                    label: 'Přidat nemovitost'
                },
                state: 'estate-add'
            },
            children: [
                {
                    path: '',
                    component: RealEstateDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'estates-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'pages-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'estates-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit nemovitost'
                },
                state: 'estate-edit'
            },
            children: [
                {
                    path: '',
                    component: RealEstateDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'estates-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'pages-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'pages-entities-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'estate_agents',
                    component: EstateAgentDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Přidat makléře'
                        },
                        state: 'estates-estate-agents-add'
                    },
                    outlet: 'modal-form'
                }
            ]
        },
        {
            path: 'delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat nemovitost'
                },
                state: 'estates-delete',
                apiUri: 'estates'
            },
            outlet: 'modal'
        },
        {
            path: 'estate-agents/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat makléře'
                },
                state: 'estate-agent-add'
            },
            children: [
                {
                    path: '',
                    component: EstateAgentDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'estate-agents-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'estate-agents-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'estate-agents-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat box'
                },
                state: 'estate_agents-delete',
                apiUri: 'estate-agents'
            },
            outlet: 'modal'
        },
        {
            path: 'developer-projects/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat developerský projekt'
                },
                state: 'developer-project-add'
            },
            children: [
                {
                    path: '',
                    component: DeveloperProjectDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'developer-projects-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'developer-projects-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'developer-projects-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'developer-projects-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat box'
                },
                state: 'developer-projects-delete',
                apiUri: 'developer-projects'
            },
            outlet: 'modal'
        },
        {
            path: 'estate-agents/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit makléře'
                },
                state: 'estate-agents-edit'
            },
            children: [
                {
                    path: '',
                    component: EstateAgentDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'estate-agents-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'estate-agents-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'estate-agents-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'developer-projects/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit developerský projekt'
                },
                state: 'developer-projects-edit'
            },
            children: [
                {
                    path: '',
                    component: DeveloperProjectDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'developer-projects-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'developer-projects-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'developer-projects-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'formrecords',
            component: EstateFormRecordsComponent,
            data: {
                breadcrumbs: {
                    label: 'Vyplněné formuláře'
                },
                state: 'estates-forms-view'
            },
            children: [
                {
                    path: 'formrecord-delete/:id',
                    component: ConfirmationComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Smazat formulářový záznam'
                        },
                        state: 'formrecord-delete',
                        apiUri: 'formrecords'
                    },
                    outlet: 'modal'
                }
            ]
        }
    ]
};

export const realEstateRoutes = appConfig.modules.realEstate ? activeModuleRoutes : defaultRoute;
